(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["languages"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function(event) {
  const selector = event.target;
  if (!selector.matches || !selector.matches('.t4s-header-language') || !selector.open) return;
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(function(alternate) {
    if (alternate.hreflang === document.documentElement.lang || alternate.hreflang === 'x-default') return;
    const url = new URL(alternate.href, window.location.href);
    if (url.origin !== window.location.origin || document.querySelector('link[data-header-language-prefetch]')) return;
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.href = url.href;
    hint.setAttribute('data-header-language-prefetch', '');
    document.head.appendChild(hint);
  });
}, true);
document.addEventListener('submit', function(event) {
  const selector = event.target.closest('.t4s-header-language');
  if (!selector) return;
  selector.open = false;
  selector.setAttribute('aria-busy', 'true');
});
window.addEventListener('pageshow', function() {
  document.querySelectorAll('.t4s-header-language[aria-busy]').forEach(function(selector) {
    selector.removeAttribute('aria-busy');
  });
});
  } catch(e) { console.error(e); }
})();

})();
